module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf+HKEdwTP+EJv9oFf+GJv+HJf+DJv+KJP6IKP6HKP2HKP+HJf6IKZNrLPQAAAAMdFJOUzMAFgMoLyE/2bOgWVMIG4kAAADWSURBVHjadZM7DsIwEERHTggCKuOIOhHQx0j0CQU1go4qSByAW9BQ0NFwII4F8ifrZPFUm6fxRFqPIa021zrdL92HhWoFo50mqNZwOuoOGuaoh3MEKi1UbQgzbeACPV0MLPpQ/CAlUirkdghPEnSazkMdhnCk4SJn9yAUuR2mn1sHG1RuepM1gf/PhKwCLZg1Qw1mTQmSNQUQWrkeTz/VzBnLbHlkhoIZIVAxIxLkzIjGr+5MRpR+yeNXsOR/1xG7OH7FkTLw2kQLxqvISxupd/wh8CfzBae8K6WnZPo7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/箭头@2x(3).png
// module id = UZAM
// module chunks = 1